var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products-wrapper"},[_c('div',{staticClass:"inner-wrapper"},_vm._l((_vm.cardsNumber),function(card){return _c('div',{key:`skeleton-card-${card}`,staticClass:"product-card"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }